import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { graphql, useStaticQuery } from 'gatsby'
import dayjs from 'dayjs'
import { Article } from '~src/types/article'
import { findImages } from '~components/homepage/utils'
import { ResponsiveImage } from '~components/homepage/styled/shared'
import { ImagesQueryData } from '~src/types/graphql-types'
import {
  ArticleDate,
  ArticleDescription,
  ArticleTitle,
  Divider,
} from './styled/shared'

const PreviewArticleContainer = styled.div`
  display: grid;
  margin-bottom: 20px;
  margin-top: 70px;
  gap: 20px;
  max-width: 325px;
`

const ArticleContentWrapper = styled.div`
  padding: 0px 20px;
  height: 190px;
  display: grid;
  grid-template-rows: 35px 1fr 85px;
  gap: 11px;
  overflow: hidden;
`

interface Props {
  article: Article
  index?: number
}

const PreviewArticle: React.FC<Props> = ({ article, index }): ReactElement => {
  const data = useStaticQuery<ImagesQueryData>(
    graphql`
      query {
        allFile(filter: { sourceInstanceName: { eq: "images" } }) {
          edges {
            node {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  originalName
                  ...GatsbyImageSharpFluid
                }
              }
              name
            }
          }
        }
      }
    `
  )

  const sliderImages = findImages(data, [article.mainPicture.src])

  const revealAnimation = {
    'data-sal': 'fade',
    // eslint-disable-next-line no-nested-ternary
    'data-sal-delay': index % 3 ? (index % 2 ? '100' : '200') : '300',
    'data-sal-duration': 500,
    'data-sal-easing': 'ease',
  }

  return (
    <div {...revealAnimation}>
      <PreviewArticleContainer>
        <a href={`/article?id=${article.id}`}>
          <ResponsiveImage
            src={sliderImages[0]?.node.childImageSharp.fluid.src}
            height="217px"
            width="100%"
          />

          <ArticleContentWrapper>
            <ArticleDate>
              {dayjs(article.date).format('DD.MM.YYYY')}
            </ArticleDate>
            <ArticleTitle>{article.title}</ArticleTitle>
            <ArticleDescription>
              {[article.content?.[0].content, article.content?.[1].content]
                .join(' ')
                .substring(0, 150)}
              ...
            </ArticleDescription>
          </ArticleContentWrapper>
        </a>
      </PreviewArticleContainer>
      <Divider />
    </div>
  )
}

export default PreviewArticle
